'use strict';

const ROLES =
  {
    ROLE_CAMPUS_ADMIN: 'ROLE_CAMPUS_ADMIN', // Campus EHS Admin
    ROLE_UCOP_ADMIN: 'ROLE_UCOP_ADMIN', // UCOP Admin
    ROLE_APP_ADMIN: 'ROLE_APP_ADMIN', // Service Desk
    AUTHORIZED_USER: 'AUTHORIZED_USER', // Members
    UNIT_REP: 'UNIT_REP' // Responsible Person
  };

module.exports = ROLES;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/server/shared/constants/role.constant.js
// module id = 2uX7
// module chunks = 1